import type { TRuleWithTheme } from '@/styles/theme';

export const container: TRuleWithTheme = ({ theme }) => ({
    display: 'grid',
    alignItems: 'center',
    justifyContent: 'center',
    height: '90vh',
    width: '100%',
});

export const overlay: TRuleWithTheme = ({ theme }) => ({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: theme.colors.black,
    opacity: 0.1,
});
